function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo } from 'react';
import { RcPopper } from '../../hooks/popper';
import { useLocale } from '@byte-design/config';
import { useRefCallback, useToggle } from '@bydesign-ui/hooks';
import { TimePopper } from '../time-picker';
import { TimeRangePanel } from '../time-range-panel';
export function TimeRangePicker(props) {
  var localePlaceholder = useLocale('time-range-picker.placeholder');

  var size = props.size,
      width = props.width,
      value = props.value,
      disabled = props.disabled,
      onChange = props.onChange,
      placement = props.placement,
      clearable = props.clearable,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? localePlaceholder : _props$placeholder,
      extra = _objectWithoutProperties(props, ["size", "width", "value", "disabled", "onChange", "placement", "clearable", "placeholder"]);

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      show = _useToggle2[0],
      handleShow = _useToggle2[1],
      handleHide = _useToggle2[2];

  var onChangeCallback = useRefCallback(onChange);
  var handleClear = useCallback(function () {
    onChangeCallback(['', '']);
  }, []);
  var wrapperData = useMemo(function () {
    return (value ? [value] : []).map(function (item) {
      return {
        label: item[0] || item[1] ? "".concat(item[0] ? item[0] : '', " ~ ").concat(item[1] ? item[1] : '') : '',
        value: item.toString()
      };
    });
  }, [value]);
  return React.createElement(RcPopper, null, React.createElement(TimePopper, {
    show: show,
    size: size,
    width: width,
    disabled: disabled,
    onShow: handleShow,
    onHide: handleHide,
    clearable: clearable,
    placement: placement,
    onClear: handleClear,
    datasource: wrapperData,
    placeholder: placeholder
  }, React.createElement(TimeRangePanel, Object.assign({}, extra, {
    onChange: onChangeCallback,
    value: value
  }))));
}